import React from 'react';
import { PlayerSearch } from '../../Form';
import { PlayerCard } from '../../cards';
import Tip from '../../Tip';
import styles from './clubAddMemberSearch.scss';

const ClubAddMembersSearch = (props) => {
    const {
        isHighSchool,
        clearPlayer,
        handlePlayerSelect,
        selectedPlayer,
        onInvitePlayersClick,
        toggleForm,
        handleCancel,
        handlePlayerSubmit,
        buttonText,
        clubLocation,
    } = props;
    const allowAddNewPlayer = false;
    return (
        <React.Fragment>
            <div className={`container bg-transparent`}>
                <div className={`row`}>
                    <div className={`offset-md-3 col-md-6`}>
                        <div className="form-group form-group-xl">
                            <label data-testid="club-add-members.search.label">Search Existing Players</label>
                            <Tip
                                variant="info"
                                valign="top"
                                showTip={true}
                                dangerouslySetInnerHTML={true}
                                content={`Can’t find a player? This means the player does not have a UTR Sports account. Once the player claims a player profile or creates a UTR Sports account, you can add the player as a member.`}
                            />
                            <PlayerSearch
                                className="form-control"
                                handlePlayerSelect={handlePlayerSelect}
                                placeholder="Search Players"
                                showInvitePlayer={false}
                                closeAfterSelect={true}
                                excludeProPlayers={true}
                                onChange={clearPlayer}
                                showSearchClearIcon={true}
                                searchMembersOnly={!isHighSchool}
                                searchParams={{}}
                                clubLocation={clubLocation}
                                isProximitySearch={true}
                                data-testid="club-add-members.player-search"
                            />
                        </div>
                        {selectedPlayer
                            ? (
                                <PlayerCard
                                    player={selectedPlayer}
                                    showSeeProfileLink={true}
                                />
                            )
                            : null}
                        <div className={`${styles.addAnotherContainer}`}>
                            {isHighSchool
                                ? (
                                    <>
                                        <span>or </span>
                                        <span
                                            className={`${styles.addAnother}`}
                                            onClick={() => {
                                                onInvitePlayersClick();
                                            }}
                                            data-testid="club-add-members.search.invite-player-link"
                                        >
                                            invite new player
                                        </span>
                                    </>
                                )
                                : (allowAddNewPlayer && (
                                    <>
                                        <span>or </span>
                                        <span
                                            className={`${styles.addAnother}`}
                                            onClick={() => {
                                                clearPlayer();
                                                toggleForm();
                                            }}
                                            data-testid="club-add-members.search.add-player-link"
                                        >
                                            add a new player
                                        </span>
                                    </>
                                )
                                )}
                        </div>
                        <div className="row">
                            <div className="col-6">
                                <button
                                    onClick={handleCancel}
                                    type="button"
                                    className="btn btn-default btn-xl text-uppercase btn-block"
                                    data-testid="club-add-members.search.cancel-btn"
                                >
                                    Cancel
                                </button>
                            </div>
                            <div className="col-6">
                                <button
                                    type="button"
                                    className="btn btn-primary btn-xl text-uppercase btn-block"
                                    onClick={handlePlayerSubmit}
                                    disabled={!selectedPlayer}
                                    data-testid="club-add-members.search.next-btn"
                                >
                                    {buttonText}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ClubAddMembersSearch;
